import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import "./forgotpassword.css";

const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const navigate = useNavigate();

    const handleReset = (e) => {
        e.preventDefault();
        alert("Reset link sent to your email (dummy message)");
    };

    return (
        <div className="fp-container">
            {/* Left Side - Logo */}
            <div className="fp-logo-section">
                <div className="fp-logo-content">
                    <div className="fp-dna-icon">
                        <img src="/Slide4.png" alt="HealthLabs AI Logo" />
                    </div>
                </div>
            </div>

            {/* Right Side - Form */}
            <div className="fp-form-section">
                <div className="fp-form-content">
                    <h2 className="fp-form-title">Forgot Password</h2>

                    <p className="fp-subtext">
                        Enter your registered email to receive reset link.
                    </p>

                    <form onSubmit={handleReset}>
                        <div className="fp-input-group">
                            <div className="fp-input-wrapper">
                                <span className="fp-input-icon">
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                                        <rect x="3" y="4" width="18" height="16" rx="2"
                                            stroke="#4a5568" strokeWidth="2" />
                                        <path d="M3 7l9 6l9-6"
                                            stroke="#4a5568" strokeWidth="2"
                                            strokeLinecap="round" />
                                    </svg>
                                </span>
                                <input
                                    type="email"
                                    placeholder="Enter your email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    className="fp-form-input"
                                    required
                                />
                            </div>
                        </div>

                        <button type="submit" className="fp-submit-button">
                            Send Reset Link
                        </button>
                    </form>

                    <div className="fp-back-link">
                        <span onClick={() => navigate("/login")}>
                            Back to Login
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ForgotPassword;
